import Container from 'react-bootstrap/esm/Container';
import Row from 'react-bootstrap/esm/Row';
import Col from 'react-bootstrap/esm/Col';
import { FaEnvelope, FaSms, FaWhatsapp, FaFacebook } from 'react-icons/fa';

const ShareLinks = () => {
 return (
  <div>
   <Container className='px-5'>
    <h2 className='text-white pt-3'>שתפו כרטיס ביקור</h2>
    <Row className='my-3'>
     <Col>
      <a
       href='mailto:?subject=%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F&amp;body=https%3A%2F%2Famsalem-david.web.app'
       title='Share via email'>
       <FaEnvelope className='text-blue' size={30} />
      </a>
     </Col>

     <Col>
      <a
       href='sms://?&amp;body=%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F%20https%3A%2F%2Famsalem-david.web.app'
       title='Share via SMS'>
       <FaSms className='text-blue' size={30} />
      </a>
     </Col>

     <Col>
      <a
       href='https://api.whatsapp.com/send?text=*%D7%93%D7%95%D7%93%20%D7%90%D7%9E%D7%A1%D7%9C%D7%9D%20-%20%D7%99%D7%95%D7%A2%D7%A5%20%D7%95%D7%9E%D7%A9%D7%95%D7%95%D7%A7%20%D7%A0%D7%93%D7%9C%22%D7%9F*%20https%3A%2F%2Famsalem-david.web.app'
       title='Share via WhatsApp'>
       <FaWhatsapp className='text-blue' size={30} />
      </a>
     </Col>

     <Col>
      <a
       href='https://www.facebook.com/sharer.php?u=https%3A%2F%2Famsalem-david.web.app'
       title='Share via Facebook'>
       <FaFacebook className='text-blue' size={30} />
      </a>
     </Col>
    </Row>
   </Container>
  </div>
 );
};

export default ShareLinks;
